module.exports = __webpack_public_path__ + "static/media/notification-white.b13c4e8b.svg";